import { Component, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

import { RecruitmentService } from '../recruitment.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IGeneralData } from 'app/shared/models/recruitment/general-data.model';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { SnotifyService, SnotifyPosition, SnotifyToastConfig } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { MatRadioChange } from '@angular/material';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { IDtoJobCandidate } from 'app/shared/models/recruitment/dto-job-candidate.model';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoJobCandidateFilter } from 'app/shared/models/recruitment/dto-job-candidate-filter.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from 'app/shared/services/storage.service';
import { map } from 'rxjs/operators';
import { SecurityService } from 'app/shared/services/security.service';
import { saveAs } from 'file-saver';
import { ModalHireEmployeeComponet } from 'app/views/modales/recruitment/hire/modal-hire-employee.component';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
@Component({
  selector: 'app-request-review',
  styleUrls: ['./request-review.style.scss'],
  templateUrl: 'request-review.template.html'
})
export class RequestReviewComponent implements OnDestroy, OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formularios */
  private formFilter: FormGroup;
  /**Notificaciones */
  private configToast: any;
  @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
  @ViewChild('swalProcessListEmployeeTxt', { static: false }) private swalProcessListEmployeeTxt: SwalComponent;
  private generalData = {} as IGeneralData;
  /**Variable de trasporte de datos */
  private result: IResult;
  /**Listas */
  private jobCandidates: IDtoJobCandidate[];
  private jobCandidatesTemp: IDtoJobCandidate[];
  /**Catalogos */
  private catalogPositions: Observable<ISelect[]>;
  private catalogZones: Observable<ISelect[]>;
  private catalogStates: Observable<ISelect[]>;
  private catalogSchoolLevels: Observable<ISelect[]>;
  //private catalogTrademarks: Observable<ISelect[]>;
  private catalogAvailabilitys: Observable<ISelect[]>;
  private catalogPhysicalComplexion: Observable<ISelect[]>;
  private catalogSkills: Observable<ISelect[]>;
  private catalogTowns: Observable<ISelect[]>;
  /** */
  @ViewChild(DatatableComponent, { static: false }) tableJobCandidates: DatatableComponent;
  /** */
  private referenceTypeLabelsMap = {
    'F': '<p><span class="label label-info">Familiar</span></p>',
    'P': '<p><span class="label label-success">Personal</span></p>'
  };
  /**Variables */
  public nav: any;
  private zones: any;
  private now: number;
  /**Slim-control */
  optsSlim: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  /**Modales */
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  private profile: string;
  private listIds = new Array();
  private search: string;
  public constructor(private modalService: BsModalService
    , private recruitmentService: RecruitmentService
    , private formBuilder: FormBuilder
    , public snotifyService: SnotifyService
    , private configGeneral: AppConfig
    , private router: Router
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private securityService: SecurityService
      , private storageService: StorageService
      , private identityService: IdentityService) {
    this.nav = document.querySelector('nav.navbar');
    this.configToast = configGeneral.getConfigToast();
    this.optsSlim = configGeneral.getConfigSlimScroll();
    this.initializeFormFilter();
    const showRoles = this.securityService.getUserRolesStorage();
    if (showRoles !== '') {
      this.zones = showRoles.listZones;
    }
    this.profile = this.securityService.getProfileStorage('RequestReviews');
  }

  public ngOnInit(): any {
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.now = Date.now();
    this.nav.className += ' white-bg';
    if (this.configurationService.isReady) {
      this.spinner.show();
      this.obetenerCatalogos();
      this.initFilters();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.spinner.show();
        this.obetenerCatalogos();
        this.initFilters();
      });
    }
  }
  private initFilters(): void {
    const values = this.storageService.retrieve('recruitments.filters');
    if (values != null) {
      this.formFilter.patchValue(values);
    }
    const search = this.storageService.retrieve('recruitments.search');
    if (search != undefined) {
      this.search = search;
    }
    let getJobCandidates = false;
    Object.keys(this.formFilter.controls).forEach(field => {
      const control = this.formFilter.get(field);
      if (control.value != null) {
        getJobCandidates = true;
        return;
      }
    });
    if (getJobCandidates) {
      this.getJobCandidatesFilters(false);
    }
    else {
      this.getJobCandidatesFilters(true);
    }
  }
  private obetenerCatalogos(): void {
    this.catalogPositions = this.recruitmentService.getCatalogPositions();
    this.catalogZones = this.configureCatalogsZones();
    if (!this.isManager()) {
      this.catalogZones.subscribe((res) => {
        this.formFilter.get('zone').setValue(res[0].id);
        //this.getJobCandidatesFilters(true);
      });
    } else {
      //this.getJobCandidatesFilters(true);
    }
    this.catalogStates = this.recruitmentService.getCatalogStates();
    this.catalogSchoolLevels = this.recruitmentService.getCatalogSchoolLevels();
    //this.catalogTrademarks = this.recruitmentService.getCatalogTrademarks();
    this.catalogAvailabilitys = this.recruitmentService.getCatalogAvailabilitys();
    this.catalogPhysicalComplexion = this.recruitmentService.getCatalogPhysicalComplexions();
    this.catalogSkills = this.recruitmentService.getCatalogSkills();
    this.spinner.hide();
  }
  private configureCatalogsZones(): Observable<ISelect[]> {
    const zonas = new Array as ISelect[];
    const t = this.recruitmentService.getCatalogZones().pipe(
      map((res: any) => {
        this.zones.forEach(element => {
          const z = res.filter(x => x.id == element.zoneId)[0];
          zonas.push(z);
        });
        return zonas;
      })
    );
    return t;
  }
  private getCatalogTowns(id: string): void {
    this.catalogTowns = this.recruitmentService.getCatalogTowns(id);
  }
  private initializeFormFilter() {
    this.formFilter = this.formBuilder.group({
      position: [null],
      age: [null],
      zone: [null],
      state: [null],
      town: [null],
      suburb: [null],
      area: [null],
      schoolLevel: [null],
      trademark: [null],
      availability: [null],
      physicalComplexion: [null],
      skill: [null],
      company: [null],
      gender: [null],
      typePosition: [null],
      birthDate: [null],
      hasCar: [null],
      name: [null],
      lastName: [null],
      secondLastName: [null],
      ageFrom: [null],
      ageTo: [null],
      periodFrom: [null],
      periodTo: [null]
    });
  }
  private mapFilters(form: any, initialize: boolean, waiting: string): IDtoJobCandidateFilter {
    const data = {} as IDtoJobCandidateFilter;
    data.positionId = form.position;
    data.age = form.age;
    data.zoneId = form.zone;
    data.stateId = form.state;
    data.town = form.town;
    data.suburb = form.suburb;
    data.area = form.area;
    data.schoolLevelId = form.schoolLevel;
    data.markId = form.trademark;
    data.availabilityId = form.availability;
    data.physicalComplexionId = form.physicalComplexion;
    data.gender = form.gender;
    data.birthDate = form.birthDate;
    data.typePosition = form.typePosition;
    data.hasCar = form.hasCar;
    data.skillId = form.skill;
    data.company = form.company;
    data.name = form.name;
    data.lastName = form.lastName;
    data.secondLastName = form.secondLastName;
    data.ageFrom = form.ageFrom;
    data.ageTo = form.ageTo;
    data.periodFrom = form.periodFrom;
    data.periodTo = form.periodTo;
    data.role = this.securityService.getProfileStorage('RequestReviews');
    data.initialize = initialize;
    data.trackingStatus = waiting;
    return data;
  }
  private openModalHireEmployee(row: IDtoJobCandidate) {
    const initialState = {
      title: 'Contratación de empleado',
      jobCandidate: row
    };
    this.modalRef = this.modalService.show(ModalHireEmployeeComponet
      , Object.assign({ initialState }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result.isCorrect) {
        this.configGeneral.newToast('Éxito', result.message, 'success');
        this.jobCandidates = [...this.removeItem(row.id)];
        this.jobCandidatesTemp = this.jobCandidates;
        this.addModuleLog(row.id);
      } else {
        this.configGeneral.newToast('Error', result.message, 'error');
      }
    });
  }
  private removeItem(id) {
    return this.jobCandidates.filter(function (element) {
      return element.id != id;
    });
  }
  private navigateTo(row: IDtoJobCandidate): void {
    const values = this.formFilter.value;
    this.storageService.store('recruitments.filters', values);
    this.storageService.store('recruitments.search', this.search);
    this.router.navigate(['/recruitments/request',
      { id: row.id, action: 'update' }], { relativeTo: this.route });
  }
  private navigateToProfile(row: IDtoJobCandidate): void {
    const values = this.formFilter.value;
    this.storageService.store('recruitments.filters', values);
    this.storageService.store('recruitments.search', this.search);
    this.router.navigate(['/recruitments/profile',
      { id: row.id }], { relativeTo: this.route });
  }
  private getJobCandidate(jobCandidateId: number): void {
    this.recruitmentService.getJobCandidate(jobCandidateId).subscribe((res) => {
      let r = res;
    });
  }
  private getJobCandidates(): void {
    this.recruitmentService.getJobCandidates().subscribe((res) => {
      this.jobCandidates = res;
      this.jobCandidatesTemp = this.jobCandidates;
      this.spinner.hide();
    });
  }
  private getJobCandidatesFilters(initialize: boolean): void {
    if (!this.isManager()) {
      if (this.formFilter.value.zone == null) {
        this.snotifyService.error('Seleccione una zona a visualizar'
          , 'Validación', this.configToast);
        return;
      }
    }
    this.spinner.show();
    const data = this.mapFilters(this.formFilter.value, initialize, null);
    this.recruitmentService.getJobCandidatesFilters(data).subscribe((res) => {
      this.jobCandidates = res;
      this.jobCandidatesTemp = this.jobCandidates;
      this.spinner.hide();
      if (this.search != undefined) {
        this.updateFilter();
      }
    });
  }
  private getJobCandidatesWaiting(): void {
    this.spinner.show();
    const data = this.mapFilters(this.formFilter.value, false, 'Waiting');
    this.recruitmentService.getJobCandidatesFilters(data).subscribe((res) => {
      this.jobCandidates = res;
      this.jobCandidatesTemp = this.jobCandidates;
      this.spinner.hide();
    });
  }
  private downloadFileEmployeeTxt(): void {
    this.listIds = new Array();
    this.jobCandidates.forEach(element => {
      this.listIds.push(element.id);
    });
    if (this.listIds.length > 0) {
      this.swalProcessListEmployeeTxt.title = `Se enviarán para descarga ${this.listIds.length} registros`;
      this.swalProcessListEmployeeTxt.show();
    } else {
      this.configGeneral.newToast('Validación', 'No existen registros para procesar', 'warning');
    }
  }
  private processListDownloadFileEmployeeTxt(): void {
    this.spinner.show();
    this.recruitmentService.downloadFileEmployeeTxt(this.listIds).subscribe((res) => {
      if (res.isCorrect) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        this.spinner.hide();
        saveAs(blob, file.fileDownloadName);
      }
      this.spinner.hide();
    });
  }
  private isManager(): boolean {
    return this.profile === 'Gerente'
  }
  private calculateAge(birthDate: Date): number {
    let age = 0;
    const d = new Date(birthDate);
    if (d) {
      const timeDiff = Math.abs(Date.now() - d.getTime());
      age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
    return age;
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }
  private getCandidatesExcel(): void {
    this.spinner.show();
    const data = this.mapFilters(this.formFilter.value, false, null);
    this.recruitmentService.getCandidatesExcel(data).subscribe((res) => {
      if (res.isCorrect === true) {
        const file = res.data as any;
        const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
        this.spinner.hide();
        saveAs(blob, file.fileDownloadName);
      }
    });
  }
  private updateFilter() {
    if (this.search === undefined) {
      return;
    }

    const val = this.search.toLowerCase();
    const temp = this.jobCandidatesTemp.filter((x: any) => x.status.toLowerCase().startsWith(val)
      || x.firstName.toLowerCase().startsWith(val)
      || x.suburb.toLowerCase().startsWith(val)
      || x.townName.toLowerCase().startsWith(val)
      || x.registryDate.toLowerCase().startsWith(val));

    this.jobCandidates = temp;
    this.tableJobCandidates.offset = 0;
  }

  private addModuleLog(id: number): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'JobCandidates';
    dto.module = "requestReviews";
    dto.action = 'hiring';
    dto.registryAffectedId = id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) =>{});
  }
}
